<template>
  <div id="MainProfile">
    <GenerlInfoView :propModel="registerModel" />
    <CategoryView class="mt-4" />
    <LocationSupView class="mt-4" />
    <ContactInfo class="mt-4" :propModel="registerModel" />
    <AttachedFileView
      class="mt-4"
      :propType="type"
      :propAttachmentDescription="descriptionModel"
      :propVendorType="vendorType"
    />
  </div>
</template>

<script>
import GenerlInfoView from "./GenerlInfoView";
import CategoryView from "./CategoryView";
import LocationSupView from "./LocationSupView";
import AttachedFileView from "./AttachedFileView";
import ContactInfo from "./ContactInfo";
import { vendorservice } from "../../services/vendorservice";

export default {
  name: "MainProfile",
  components: {
    GenerlInfoView,
    CategoryView,
    LocationSupView,
    AttachedFileView,
    ContactInfo,
  },

  data: () => ({
    registerModel: {},
    commercialType: [],
    vendorCatListModel: [],
    vendorLocationList: [],
    attachments: [],
    vendorId: 0,
    userName: "",
    gulfContactPoint: [],
    descriptionModel: {
      RegisteredCapital: 0,
      ExperienceIn: "",
      ExperienceYear: 0,
      ExperienceMonth: 0,
      ISOName: "",
      LicenseName: "",
    },
    vendorType: "",
  }),
  async mounted() {
    this.getVendorInfo();
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    type() {
      if (this.registerModel.commercialTypeId === 1) return "1";
      else {
        if (
          this.registerModel.commercialTypeId === 3 ||
          this.registerModel.commercialTypeId === 4
        )
          return "3";
        return "2";
      }
    },
  },
  methods: {
    async getVendorInfo() {
      const vendorInfo = await vendorservice.GetVendorInfo(
        this.activeUserInfo.vendorID
      );
      this.vendorId = vendorInfo.vendorId;
      this.userName = vendorInfo.taxId;
      this.vendorType = vendorInfo.vendorType;
      this.registerModel = vendorInfo;
      if (this.registerModel.vendorType === "domestic") this.setLocale("th");
      else this.setLocale("en");
      this.getAttachmentDescription(vendorInfo);
    },
    async getAttachmentDescription(val) {
      // Set description model
      this.descriptionModel.RegisteredCapital = parseFloat(
        val.registeredCapital
      );
      this.descriptionModel.ExperienceIn = val.experienceIn;

      var years =
        new Date(
          new Date() - new Date(val.companyEstablishDate)
        ).getFullYear() - 1970;
      var month = new Date(
        new Date() - new Date(val.companyEstablishDate)
      ).getUTCMonth();

      this.descriptionModel.ExperienceYear = years;
      this.descriptionModel.ExperienceMonth = month;
      this.descriptionModel.ISOName = val.isoname;
      this.descriptionModel.LicenseName = val.licenseName;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router
        .push({
          params: {
            lang: locale,
          },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
